export default __webpack_public_path__ + "static/media/529_light.de24242d.png";